import { maskPhone } from "@/components/wizard/masks";

import type { FieldKind } from "./fields";

function maskCpf(v: string) {
	const d = v.replaceAll(/\D/gu, "").slice(0, 11);

	if (d.length > 9) {
		return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
	}

	if (d.length > 6) {
		return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
	}

	if (d.length > 3) {
		return `${d.slice(0, 3)}.${d.slice(3)}`;
	}

	return d;
}

function maskCep(v: string) {
	const d = v.replaceAll(/\D/gu, "").slice(0, 8);

	if (d.length > 5) {
		return `${d.slice(0, 5)}-${d.slice(5)}`;
	}

	return d;
}

export function maskFor(kind: FieldKind) {
	if (kind === "cpf") {
		return maskCpf;
	}

	if (kind === "tel") {
		return maskPhone;
	}

	if (kind === "cep") {
		return maskCep;
	}

	return (v: string) => v;
}
